module.exports = __webpack_public_path__ + "img/simpra-slider1.bda63d3a.webp";